import React from 'react';
import PropTypes from 'prop-types';
import { MenuButton, ListItem } from 'react-md';

const KebabMenu = ({ id, className, menuItems, iconName }) => (
  <MenuButton id={id} icon className={className} menuItems={menuItems}>
    {iconName}
  </MenuButton>
);

KebabMenu.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  menuItems: PropTypes.array,
  iconName: PropTypes.string
};

KebabMenu.defaultProps = {
  className: '',
  menuItems: [
    <ListItem
      key={1}
      primaryText="Settings"
      onClick={(...events) => {
        // eslint-disable-next-line no-console
        console.log('onClick::Settings', events);
      }}
    />,
    <ListItem
      key={2}
      primaryText="Login"
      onClick={(...events) => {
        // eslint-disable-next-line no-console
        console.log('onClick::Login', events);
      }}
    />
  ],
  iconName: 'more_vert'
};

export default KebabMenu;
